import React, { Component } from 'react';
import { Link } from "react-router-dom";

import config from './../config';

class FlokkurInfoView extends Component {
	constructor(props) {
		super(props);

		this.url = config.apiRoot+'/api/flokkar/';

		this.state = {};
	}

	componentDidMount() {
		if (this.props.flokkur) {
			this.fetchData();
		}
	}

	componentDidUpdate(prevProps, prevState) {
		console.log(this.props)
		// Athuga hvort breytur hafi breyst og hvort component eigi að uppfærast
		if (this.props.flokkur && this.props.flokkur != prevProps.flokkur) {
			this.fetchData();
			console.log('fetchData')
		}
	}

	fetchData() {
		// Sæki gögn til APA
		console.log('fetchData')
		this.setState({
			initialized: false
		});

		fetch(this.url+this.props.flokkur)
			.then(function(response) {
				return response.json();
			})
			.then(function(json) {
				this.setState({
					data: json
				});
			}.bind(this));
	}

	render() {
		return (
			<React.Fragment>
				{
					this.state.data && this.state.data.lysing &&
						<div className="content-container manual-init initialized category-info">
							<h3><span>{this.state.data.heiti}</span></h3>
							<div className="page-content">
								<p>
									{this.state.data.lysing.split('\n').map(function(item, index) {
										return <React.Fragment>
											{item}
											{
												index < this.state.data.lysing.split('\n').length-1 &&
												<br/>
											}
										</React.Fragment>
									}.bind(this))}
								</p>
							</div>
						</div>
				}
			</React.Fragment>
		);
	}
}

export default FlokkurInfoView;



// WEBPACK FOOTER //
// ./src/components/FlokkurInfoView.js